import { B as BaseComponent, _ as __decorate, a as __metadata } from '../index-C155IGn1.js';
import { css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import 'lit/directive.js';

var styles = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

p {
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: var(--bsi-spacing-s);
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: var(--bsi-spacing-l);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: var(--bsi-font-weight-strong);
}

dd {
  margin-bottom: var(--bsi-spacing-xxs);
  margin-left: 0;
}

blockquote {
  margin: 0 0 var(--bsi-spacing-s);
}

sub,
sup {
  position: relative;
  font-size: var(--bsi-font-size-1);
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  cursor: pointer;
}

pre,
code,
kbd,
samp {
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
  overflow: auto;
}
pre code {
  word-break: normal;
}

a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: hsl(210, 17%, 44%);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.pagescroll-scroll-disabled {
  scroll-behavior: auto !important;
}

:host {
  display: flex;
  padding-left: 0;
  list-style: none;
  height: fit-content;
}

::slotted(a.page-link) {
  position: relative;
  display: flex;
  min-width: var(--bsi-pagination-item-size);
  align-items: center;
  justify-content: center;
  padding: var(--bsi-pagination-padding-y) var(--bsi-pagination-padding-x);
  border: var(--bsi-pagination-border-width) solid var(--bsi-pagination-border-color);
  border-radius: var(--bsi-pagination-border-radius);
  color: var(--bsi-pagination-link-color) !important;
  font-weight: var(--bsi-font-weight-solid);
  gap: 0.25rem;
  font-size: var(--bsi-pagination-font-size, 1rem);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  ::slotted(a.page-link) {
    transition: none;
  }
}
::slotted(a.page-link):hover {
  --bsi-pagination-border-color: var(--bsi-color-border-primary-hover);
  --bsi-pagination-link-color: var(--bsi-color-link-hover);
  text-decoration: underline;
}
::slotted(a.page-link):focus-visible {
  outline: 2px solid #0066cc !important;
  outline-offset: 2px !important;
}

::slotted(span.page-link) {
  position: relative;
  display: flex;
  min-width: var(--bsi-pagination-item-size);
  align-items: center;
  justify-content: center;
  padding: var(--bsi-pagination-padding-y) var(--bsi-pagination-padding-x);
  border: var(--bsi-pagination-border-width) solid var(--bsi-pagination-border-color);
  border-radius: var(--bsi-pagination-border-radius);
  color: var(--bsi-pagination-link-color) !important;
  font-weight: var(--bsi-font-weight-solid);
  gap: 0.25rem;
  font-size: var(--bsi-pagination-font-size, 1rem);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  ::slotted(span.page-link) {
    transition: none;
  }
}

.page-item.active ::slotted(.page-link) {
  --bsi-pagination-border-color: var(--bsi-color-border-primary-active);
  --bsi-pagination-link-color: var(--bsi-color-link-active);
  pointer-events: none;
}

.page-item.disabled ::slotted(.page-link) {
  border-color: var(--bsi-pagination-disabled-border-color);
  background-color: var(--bsi-pagination-disabled-bg);
  color: var(--bsi-pagination-disabled-color);
  pointer-events: none;
}

:host(:first-of-type) ::slotted(.page-link) {
  border-top-left-radius: var(--bsi-pagination-border-radius);
  border-bottom-left-radius: var(--bsi-pagination-border-radius);
}

:host(:last-of-type) ::slotted(.page-link) {
  border-top-right-radius: var(--bsi-pagination-border-radius);
  border-bottom-right-radius: var(--bsi-pagination-border-radius);
}

.page-link[aria-current] {
  --bsi-pagination-border-color: var(--bsi-color-border-primary-active);
  --bsi-pagination-link-color: var(--bsi-color-link-active);
  pointer-events: none;
}`;

let ItPaginationItem = class ItPaginationItem extends BaseComponent {
    constructor() {
        super(...arguments);
        this.page = '';
        this.current = false;
        this.disabled = false;
    }
    updated(changedProperties) {
        super.updated?.(changedProperties);
        // When current or disabled state changes, update the slotted elements
        if (changedProperties.has('current') || changedProperties.has('disabled')) {
            this.updateSlottedElements();
        }
    }
    updateSlottedElements() {
        const slot = this.shadowRoot?.querySelector('slot');
        if (!slot)
            return;
        const assignedElements = slot.assignedElements();
        assignedElements.forEach((element) => {
            // Gestione accessibilità per l'elemento interno (es. <a> o <button>)
            if (this.current) {
                element.setAttribute('aria-current', 'page');
            }
            else {
                element.removeAttribute('aria-current');
            }
            if (this.disabled) {
                element.setAttribute('aria-disabled', 'true');
                element.setAttribute('tabindex', '-1');
            }
            else {
                element.removeAttribute('aria-disabled');
                element.removeAttribute('tabindex');
            }
            element.classList.add('page-link');
            element.removeEventListener('click', this.handleClick);
            element.addEventListener('click', this.handleClick.bind(this));
        });
    }
    handleSlotChange() {
        // Initial setup when slot content changes
        this.updateSlottedElements();
    }
    handleClick(e) {
        // Se disabilitato o già attivo, ignoriamo il click
        if (this.disabled || this.current) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        // Emettiamo un evento "interno" che il padre (ItPagination) ascolterà.
        // Usiamo bubbles: true per risalire il DOM fino al padre.
        this.dispatchEvent(new CustomEvent('it-item-click', {
            detail: { page: this.page },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        // La classe 'page-item' va sul contenitore LI per Bootstrap
        const liClasses = this.composeClass('page-item', this.current && 'active', this.disabled && 'disabled');
        return html `
      <li class="${liClasses}">
        <slot @slotchange="${this.handleSlotChange}"></slot>
      </li>
    `;
    }
};
ItPaginationItem.styles = styles;
ItPaginationItem.shadowRootOptions = { ...BaseComponent.shadowRootOptions, delegatesFocus: true };
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItPaginationItem.prototype, "page", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItPaginationItem.prototype, "current", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItPaginationItem.prototype, "disabled", void 0);
ItPaginationItem = __decorate([
    customElement('it-pagination-item')
], ItPaginationItem);

export { ItPaginationItem };
//# sourceMappingURL=it-pagination-item.js.map
